module.exports = __webpack_public_path__ + "img/ic_services_spahealthcenter.2901da31.svg";